import React, { useCallback, useImperativeHandle, useState } from 'react';
import {
    DataGridPro, GridToolbarFilterButton
    , GridToolbarColumnsButton, GridToolbarExport, GridToolbarContainer
    , GridToolbarQuickFilter, useGridApiRef, GridFooterContainer, GridPagination
} from '@mui/x-data-grid-pro';
import { Tooltip, tooltipClasses, Typography, Grid, Box, Button, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import { toast } from 'react-toastify';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { GridFilterPanel, useGridApiContext } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';



//import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const Styles = theme => ({
    root: {
        '& .MuiDataGrid-main': {
            fontSize: '0.75rem',
            padding: '8px',
            color: 'inherit',
            border: 0,
            cursor: 'pointer',
            margin: 0,
            outline: 0,
            padding: 0,
            //userSelect: 'none',
            borderRadius: 0,
            textDecoration: 'none',
            backgroundColor: 'transparent',
            //height: 560
            //height:576
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            overflow: 'hidden !important',
            fontWeight: 500,
            whiteSpace: 'break-spaces',
            lineHeight: '1.4em',
            maxHeight: 'unset !important',
            height: 'fit-content'
        },
        '& .MuiDataGrid-footerContainer, & .MuiToolbar-gutters p': {
            color: 'inherit', fontSize: '0.75rem'
        },
        '&': {
            clear: 'both'
        },
        '&::before': {
            clear: 'both'
        },
        '&::after': {
            clear: 'both'
        },
        '& .MuiDataGrid-cell,& .MuiDataGrid-cell:focus': {
            whiteSpace: 'break-spaces !important',

            maxHeight: 'unset !important',
            padding: '0 10px !important',
            outline: 'none'
        },
        '& .MuiDataGrid-row': {
            maxHeight: 'unset !important'
        },
        '& .MuiDataGrid-cell .MuiInput-input, .MuiDataGrid-editInputCell': {
            color: '#414141',
            height: '29px',
            padding: '7px 10px 7px 10px',
            width: '66%',
            outline: 'none',
            border: '1px solid #c6c6c6',
            borderRadius: 6,
            transition: '0.3s ease-in-out all'
        },
        '& .MuiDataGrid-columnHeader:focus-within,& .MuiDataGrid-cell:focus': {
            outline: 'none  !important'
        },
        '& .MuiDataGrid-editInputCell, .MuiDataGrid-editInputCell input': {
            margin: 0,
            // padding: '0 !important',
            padding: '7px 4px 7px 4px  !important',
            FontFace: 'Lato, sans-serif !important',
            fontSize: '12px'
        },
        '& .MuiToolbar-gutters p': {
            margin: 0
        },
        '& .MuiTablePagination-select': {
            padding: "4px 0 2px", fontSize: '0.75rem'
        },
        '& .MuiDataGrid-cell.MuiDataGrid-cell--editing': {
            padding: '0 10px !important'
        },
        '& [data-field="actions"]': {
            textAlign: 'center'
        },
        '& div.MuiDataGrid-toolbarContainer': {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            justifyContent: 'flex-start'
        },
        '& div.MuiDataGrid-toolbarContainer .MuiBox-root': {
            display: 'none'
        },
        '& .MuiButtonBase-root.MuiButton-root.MuiButton-text': {
            color: 'inherit', fontSize: '0.75rem'
        }
    }
});
const StyledGridFilterPanel = styled(GridFilterPanel)(({ theme }) => ({
    '& button.MuiButton-root:has(svg[data-testid="DeleteIcon"])': {
        // display: 'none',
      
    },
    '& .MuiDataGrid-panelFooter': {
        justifyContent:'flex-start !important'
    }
}));

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#2c2c2c',  // Dark black
        color: '#fff',               // White text
        fontSize: '13px',
        fontWeight: 600,
        borderRadius: '4px',
        boxShadow: 'none',
        padding: '6px 10px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#2c2c2c',
    },
}));

const CustomFooter = ({ footerMessage, hidePagination }) => {
    return (
        <GridFooterContainer sx={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px' }}>

            <Typography variant="body2" sx={{ fontSize: '13px' }}>{footerMessage}</Typography>
            {!hidePagination && <GridPagination />}
        </GridFooterContainer>
    );
};
function EnhancedDataGrid(props) {

    //#region variables
    const serverExport = React.useMemo(() => props.serverExport, [props.serverExport])
    const [disableTooltip, setDisableTooltip] = React.useState(false);

    //#region local variables
    //#end region

    const apiRef = useGridApiRef();
    let [pageSize, setPageSize] = useState(props.pageSize || 10)
    const [allVisbleColumn, setAllVisibleColumn] = React.useState(true);
    const [filterText, setFilterText] = useState(props?.filterText || '');
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterValues: [props?.filterText || ''],
        logicOperator: 'and'
    });
    const [isFiltered, setIsFiltered] = useState(1);
    const [initialLoad, setInitialLoad] = useState(1);
    const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);
    const [filterSnapshot, setFilterSnapshot] = useState(null); // Snapshot of filters when panel opens

   
    React.useEffect(() => {

        if (props?.filterMode === 'server') {
            let filterValue = filterModel?.quickFilterValues.join(' ') || '';
            let _isFiltered = isFiltered;
            if (isFiltered) {
                _isFiltered = 0;
            }
            if (initialLoad) {
                _isFiltered = 1;
            }
            if (!_isFiltered && !filterValue && !initialLoad) {
                if (props?.searchCallback && typeof props?.searchCallback === 'function') {
                    props?.searchCallback('')
                    _isFiltered = 1;
                }
            }
            setIsFiltered(_isFiltered);
        }

        if (initialLoad) {
            setInitialLoad(0);
        }
    }, [filterModel?.quickFilterValues]);

    React.useEffect(() => {
        if (!initialLoad) {
            if (isFilterMenuOpen) {
                setFilterSnapshot({ items: [...filterModel.items], logicOperator: filterModel.logicOperator }); // Store the snapshot of filters when the panel opens
            } else {
                // Panel just closed, compare old snapshot and new filters
                if (JSON.stringify(filterSnapshot) !== JSON.stringify({ items: [...filterModel.items], logicOperator: filterModel.logicOperator })) {
                    let updatedModel = {
                        ...filterModel
                    };
                    (props?.setFilterModel && props?.setFilterModel(updatedModel));
                    if (props?.filterMode === 'server') {
                        toolbarmethods.customFilters(updatedModel)
                    }

                }
            }
        }


    }, [isFilterMenuOpen]);


    const onPageSizeChange = useCallback((newPageSize) => {
        if (this.props.onPageSizeChange && typeof (this.props.onPageSizeChange) == 'function') {
            this.props.onPageSizeChange(newPageSize)
        }
        setPageSize(newPageSize)
    });
    const onSelectionModelChange = useCallback((model) => {
        if (props.onSelectionChange && typeof (props.onSelectionChange) == 'function') {
            let selectedRows = [];
            (props.apiRef || apiRef).current.getSelectedRows().forEach((e) => {
                selectedRows.push(e);
            })
            props.onSelectionChange(selectedRows);
        }
    });
    const toolbarmethods = React.useMemo(() => {
        return {
            getfiltertext: (text) => {
                setFilterText(text);
                if (props?.setFilterText && typeof props?.setFilterText === 'function') {
                    props?.setFilterText(text);
                }
            },
            serverFilter: (input, sender) => {
                const filterValue = filterModel?.quickFilterValues.join(' ') || '';

                // ✅ lock tooltip only on first actual search (not empty)
                if (!disableTooltip && filterValue.trim() !== '') {
                    setDisableTooltip(true); // 🔒 lock it forever
                }

                if (props?.searchCallback && typeof props?.searchCallback === 'function') {
                    if (sender === 'filter') {
                        props?.searchCallback((input === '') ? input : filterValue);
                    } else {
                        if (filterValue || !isFiltered) {
                            props?.searchCallback(filterValue);
                        }
                    }
                    setIsFiltered(1);
                }
            },

            customFilters: () => {
                if (props?.customServerFilter && typeof props?.customServerFilter === 'function') {
                    props?.customServerFilter(filterModel)
                    setIsFiltered(1);
                }
            },
            downloadcsv: () => {
                props?.exportServerCallback();
            },
            onSearchFocus: props?.onSearchFocus

        }
    }, [filterModel, isFiltered, props?.exportServerCallback])
    const onColumnVisbilityModelChange = React.useCallback((newModel) => {
        if (props?.options?.columnsButton) {
            let modelLength = Object.keys(newModel).length;
            let someChecked = Object.keys(newModel).some(e => newModel[e]);
            let isAllVisible = modelLength === 0 || someChecked
                || (!someChecked && modelLength < props.columns.length);
            setAllVisibleColumn(isAllVisible);
        }

        if (typeof props.onColumnVisbilityModelChange == "function") {
            props.onColumnVisbilityModelChange(newModel);
        }
    }, [props]);


    const expandIcon = () => {
        return <ExpandMoreIcon
            sx={{
                transform: 'rotate(270deg)',
                transition: (theme) =>
                    theme.transitions.create('transform', {
                        duration: theme.transitions.duration.shortest,
                    }),
            }}
            fontSize="inherit"
        />
    };
    const collapeIcon = () => {
        return <ExpandMoreIcon
            sx={{
                transform: 'rotate(0deg)',
                transition: (theme) =>
                    theme.transitions.create('transform', {
                        duration: theme.transitions.duration.shortest,
                    }),
            }}
            fontSize="inherit"
        />
    };

    useImperativeHandle(props.gridRef, () => {
        return {
            ...apiRef.current,
            filterText: filterText,
            pageSize: pageSize
        }
    }, [pageSize, filterText, apiRef.current]);
    var psize = pageSize;
    var pagingOptions = [5, 10, 20, 50, 100];
    if (props.rowsPerPageOptions) {
        pagingOptions = props.rowsPerPageOptions;
    }


    const filterModelCallback = React.useCallback((newModel) => {

        //if (filterModel.quickFilterValues?.length > 0 && newModel.quickFilterValues?.length === 0 && !isFiltered) {
        //    toolbarmethods.serverFilter('', 'filter')
        //}

    
        const prevQuick = filterModel?.quickFilterValues || [];
        const prevText = (prevQuick.join(' ') || '').trim();
        const newText = (newModel.quickFilterValues?.join(' ') || '').trim();

        const isClearingQuickFilter =
            prevText.length > 0 &&      
            newText === '' &&              
            toolbarmethods?.onSearchFocus;


        if (isClearingQuickFilter) {
            toolbarmethods.onSearchFocus();
        }

        toolbarmethods.getfiltertext(newModel.quickFilterValues?.join(' ') || '');
        setFilterModel(newModel);

        if (props?.onFilterModelChange && typeof props.onFilterModelChange === 'function') {
            props.onFilterModelChange(newModel);
        }

    }, [filterModel, isFiltered, isFilterMenuOpen, toolbarmethods])

    const renderFilterPanel = useCallback((panelProps) => {
        return props.customFilterPanel
            ? <MemoizedFilterPanel {...panelProps} onSearchClick={props.onFilterPanelSearch} />
            : <StyledGridFilterPanel {...panelProps} />;
    }, [props.customFilterPanel, props.onFilterPanelSearch]);


    return (
        <DataGridPro
            {...props}
            autoHeight={props.autoHeight ?? false}
            sx={{
                ...props.sx,
                ...(props.autoHeight
                    ? {
                        '& .MuiDataGrid-main': {
                            height: 'auto'
                        }
                    }
                    : {
                        //'& .MuiDataGrid-main': {
                        //    height: '560px'
                        //}

                        '& .MuiDataGrid-main': {
                            height: typeof props.height === 'number'
                                ? `${props.height}px`
                                : (props.height || '560px')
                        }
                    }),
                '& .MuiDataGrid-cell:focus,& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within,& .MuiDataGrid-cell:focus-within': {
                    outline: 'none !important', padding: '0 10px !important'
                },
                '& .MuiDataGrid-columnHeader': {
                    outline: 'none !important'
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                    height: '0.7em',
                    width: '0.7em'
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:vertical , .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:horizontal': {
                    background: '#B2b2b2', borderRadius: 2, opacity: '0.5'
                }
            }}
            apiRef={props.apiRef || apiRef}
            className={props.classes.root}
            initialState={{
                ...props.initialState,
                pagination: { paginationModel: { pageSize: psize } },
                filter: {
                    filterModel: {
                        items: [],
                        quickFilterExcludeHiddenColumns: false,
                    },
                },
            }}
            pageSizeOptions={pagingOptions}
            disableColumnFilter={!props?.options?.filtering}
            disableColumnSelector={!props?.options?.columnsButton}
            disableDensitySelector
            disableRowSelectionOnClick
            disableColumnMenu
            onPageSizeChange={onPageSizeChange}
            checkboxSelection={props && props.onSelectionChange && typeof (props.onSelectionChange) === 'function'}
            onRowSelectionModelChange={onSelectionModelChange}
            onFilterModelChange={filterModelCallback}

            // ✅ ALLOW INJECTING CUSTOM PANELS LIKE filterPanel
            slots={{
                ...props.slots,
                toolbar: DataGridTitle,
                detailPanelExpandIcon: expandIcon,
                detailPanelCollapseIcon: collapeIcon,
                filterPanel: renderFilterPanel,
                footer: () => <CustomFooter footerMessage={props.footerMessage} hidePagination={props.hidePagination} />,
            }}

            // ✅ ALLOW SLOT PROPS TO BE EXTENDED FROM OUTSIDE
            slotProps={{
                ...props.slotProps,
                panel: {
                    placement: "bottom-end"
                },
                filterPanel: {
                    disableAddFilterButton: false,
                    disableRemoveAllButton: false,
                },
                toolbar: {
                    apiRef: apiRef,
                    title: props.title,
                    tooltipMessage: props.toolTipMessage,
                    hasSearchedOnce: props.hasSearchedOnce,
                    showSearchTooltip: props.showSearchTooltip && !disableTooltip,
                    searchButton: props.searchButton,
                    showSearchButtonInToolbar: props.showSearchButtonInToolbar,
                    showquickfilter: props.nofilter ? 0 : 1,
                    leftCustomComponent: props.leftCustomComponent || null,
                    customcomponent: props.customcomponent || null,
                    printoptions: {
                        disableToolbarButton: true
                    },
                    isallcolumnvisible: allVisbleColumn ? 1 : 0,
                    columnsselector: props?.options?.columnsButton?.toString(),
                    filtering: props?.options?.filtering?.toString(),
                    csvbutton: props?.options?.exportButton?.toString(),
                    toolbarmethods: toolbarmethods,
                    filtermode: (props?.filterMode || ''),
                    serverexport: (serverExport ? '1':'0'),
                    filterref: toolbarmethods,
                    csvoptions: {
                        allColumns: !props?.options?.exportAllData,
                        fileName: props?.options?.exportFileName,
                        disableToolbarButton: !props?.options?.exportButton
                    },
                    filterText: props.filterText,
                    isWeeksToFilterSearchActive: props.isWeeksToFilterSearchActive,
                    highlightSearchTextOnMainScreenGrid: props?.highlightSearchTextOnMainScreenGrid || false,
                    quickFilterDebounceMs: props.quickFilterDebounceMs

                }
            }}

            onColumnVisibilityModelChange={onColumnVisbilityModelChange}
            onStateChange={(state) => {
                let panelProps = state.preferencePanel;
                if (panelProps?.openedPanelValue && panelProps.open) {
                    setIsFilterMenuOpen(true);
                } else if (!panelProps.open) {
                    setIsFilterMenuOpen(false);
                }
            }}
        />
    );

}
function DataGridTitle(props) {
    let max_size = 12;
    let column_size = 5 - (props.customcomponent && 1 || 0) - (props.filtering && 1 || 0) - (props.columnsselector && 1 || 0) - (props.csvbutton && 1 || 0);
    let columns_size_2 = max_size - column_size;
    let toolbarSize = 4 + Math.floor((props.filtering && 0.5 || 0) + (props.columnsselector && 0.5 || 0) + (props.csvbutton && 0.5 || 0))
    return (
        <div style={{ width: '100%' }} id="dataGridtitle">
            <Grid key={1} item sx={{ pt: 1, pl: 1, pr: 1, pb: 1 }} container xs={12}>
                <Grid key={1} sx={{
                    '&': {
                        display: 'flex', marginTop: '10px !important',
                        alignItems: 'center', height: 'fit-content'
                    }
                }} item xs={column_size}>
                    <div style={{ width: "100%", display: "flex", textOverflow: 'elipses', }}>
                        {(props.leftCustomComponent) ? (
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                                {props.leftCustomComponent }
                            </div>
                        ) : null}
                        <Typography key={1} style={{
                            width: 'calc(100% - 0px)',
                            maxWidth: 'calc(100% - 0px)',
                            paddingLeft: '10px',
                            overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
                        }}
                            title={props.title}
                            variant="h6">{props.title}</Typography>
                    </div>
                </Grid>
                <Grid key={2} item xs={columns_size_2}>
                    <div style={{ width: '100%' }}>
                        <Grid key={1} container item xs={12} justifyContent="flex-end">
                            <Grid key={1} sx={{ pr: (props.customcomponent) ? 1 : 0 }}
                                style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}
                                item xs={(props.customcomponent) ? toolbarSize : 12} alignItems="flex-end">
                                <GridCustomToolBar
                                    key={1}
                                    sx={{
                                        '& .MuiInput-underline:before': {
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important'
                                        },
                                        '& .MuiFormControl-root[aria-label="Search"]': {
                                            paddingBottom: '2px'
                                        }
                                    }}
                                    apiRef={props.apiRef}
                                    title={props.title}
                                    tooltipMessage={props.tooltipMessage}
                                    hasSearchedOnce={props.hasSearchedOnce}
                                    filterText={props.filterText}
                                    isWeeksToFilterSearchActive={props.isWeeksToFilterSearchActive}
                                    highlightSearchTextOnMainScreenGrid={props.highlightSearchTextOnMainScreenGrid}
                                    showSearchTooltip={props.showSearchTooltip}
                                    toolbarmethods={props.toolbarmethods}
                                    filtermode={props.filtermode}
                                    searchButton={props.searchButton}
                                    showSearchButtonInToolbar={props.showSearchButtonInToolbar}
                                    csvbutton={props.csvbutton}
                                    csvoptions={props.csvoptions}
                                    columnsselector={props.columnsselector}
                                    filtering={props.filtering}
                                    isallcolumnvisible={props.isallcolumnvisible}
                                    printoptions={props.printoptions}
                                    customcomponent={props.customcomponent}
                                    showquickfilter={props.showquickfilter}
                                    nofilter={props.nofilter}
                                    serverexport={props.serverexport}
                                    quickFilterDebounceMs={props.quickFilterDebounceMs}

                                />

                            </Grid >
                            {
                                (props.customcomponent) ?
                                    <Grid key={2} alignItems="center" >
                                        {props.customcomponent}
                                    </Grid> : <></>
                            }
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </div>
    )

}
function GridCustomToolBar({
    apiRef,
    sx,
    tooltipMessage,
    hasSearchedOnce,
    showSearchTooltip,
    toolbarmethods,
    searchButton,
    showSearchButtonInToolbar,
    filtermode,
    csvbutton,
    csvoptions,
    columnsselector,
    filtering,
    isallcolumnvisible,
    printoptions,
    customcomponent,
    showquickfilter,
    serverexport,
    nofilter,
    filterref,
    filterText,
    isWeeksToFilterSearchActive,
    highlightSearchTextOnMainScreenGrid,
    ...muiProps
}) {
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const intervalRef = React.useRef(null);
    const timeoutRef = React.useRef(null);
    const hasSearchedOnce_ = React.useRef(false); 
    const areFiltersAppliedOnSearch = apiRef.current?.state?.filter?.filterModel?.quickFilterValues ?? false;

    // For debounced quickfilter: opt-in debounce controls
    const { quickFilterDebounceMs } = muiProps;
    const debounceMs =
        typeof quickFilterDebounceMs === 'number' && quickFilterDebounceMs > 0
            ? quickFilterDebounceMs
            : null;
    const useDebounce = !!debounceMs;

    const [inputValue, setInputValue] = React.useState(filterText || '');
    const typingTimerRef = React.useRef(null);

    React.useEffect(() => {
        if (!useDebounce) return;
        const current =
            apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') ||
            muiProps?.filterText ||
            '';
        setInputValue(current);
    }, [useDebounce, muiProps?.filterText]);



    // For debounced quickfilter: If grid quick filter is cleared (via ✕), also clear input + storage
    React.useEffect(() => {
        if (!useDebounce) return;

        const handleFilterModelChange = (model) => {
            const q = (model?.quickFilterValues?.join(' ') || '');
            setInputValue(q);
            toolbarmethods?.getfiltertext?.(q);  // keep storage aligned with the grid
            if (q === '' && typingTimerRef.current) clearTimeout(typingTimerRef.current);
        };

        const unsub1 = apiRef.current?.subscribeEvent?.('filterModelChange', handleFilterModelChange);
        const unsub2 = apiRef.current?.subscribeEvent?.('stateChange', (state) => {
            const q = (state?.filter?.filterModel?.quickFilterValues?.join(' ') || '');
            setInputValue(q);
        });

        return () => { unsub1?.(); unsub2?.(); };
    }, [useDebounce]);



    React.useEffect(() => {
        if (!showSearchTooltip || hasSearchedOnce) {
            setTooltipOpen(false);
            return;
        }
        setTooltipOpen(true);
        timeoutRef.current = setTimeout(() => {
            setTooltipOpen(false);
        }, 30000);

        intervalRef.current = setInterval(() => {
            let searchValue = apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '';
            if (!hasSearchedOnce && searchValue.trim() === '') {
                setTooltipOpen(true);
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => {
                    setTooltipOpen(false);
                }, 20000);
            }
        }, 45000);

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [showSearchTooltip, hasSearchedOnce]); 


    // For debounced quickfilter: store immediately; filter after debounce
    const handleChangeDebounced = (event) => {
        const value = event.target.value;
        setInputValue(value); 

        if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
        typingTimerRef.current = setTimeout(() => {
            if (muiProps?.filtermode !== 'server') {
                apiRef.current?.setQuickFilterValues?.([value]);
            }
            toolbarmethods?.getfiltertext?.(value);
        }, debounceMs);

        if (tooltipOpen) {
            setTooltipOpen(false);
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    };

    // For debounced quickfilter:
    const handleSubmitDebounced = (event) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
            const value = (inputValue ?? '').trim();
            if (value !== '') hasSearchedOnce_.current = true;

            apiRef.current?.setQuickFilterValues?.([value]); 
            toolbarmethods?.getfiltertext?.(value);         
            toolbarmethods?.serverFilter?.(value);           

            event.preventDefault?.();
            clearInterval?.(intervalRef.current);
            clearTimeout?.(timeoutRef.current);
            setTooltipOpen(false);
        }
    };
    //For debounced quickfilter:
    const handleSearchClickDebounced = () => {
        if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
        const value = (inputValue ?? '').trim();
        if (value !== '') {
            hasSearchedOnce_.current = true;
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setTooltipOpen(false);
        }
        apiRef.current?.setQuickFilterValues?.([value]); 
        toolbarmethods?.getfiltertext?.(value);          
        toolbarmethods?.serverFilter?.(value);         
    };



    const handleChange = (event) => {
        const value = event.target.value;
        if (apiRef.current?.setQuickFilterValues) {
            apiRef.current.setQuickFilterValues([value]);
        }
        //setSearchValue(value);
       

        if (tooltipOpen) {
            setTooltipOpen(false);
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }

        toolbarmethods?.getfiltertext(value);
    };
    const handleSubmit = (event) => {
        let searchValue = apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '';
        if (event.key === 'Enter' || event.key === 'Tab') {
            if (searchValue.trim() !== '') {
                hasSearchedOnce_.current = true;
            }

            toolbarmethods?.getfiltertext(searchValue);
            toolbarmethods?.serverFilter(searchValue);
            event.preventDefault();
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
            setTooltipOpen(false);
        }
    };
    const handleSearchClick = () => {
        let searchValue = apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '';
        const trimmed = searchValue.trim();
        if (trimmed !== '') {
            hasSearchedOnce_.current = true;

            //  Manually stop tooltip cycle IMMEDIATELY
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setTooltipOpen(false);
        }

        toolbarmethods?.getfiltertext(trimmed);
        toolbarmethods?.serverFilter(trimmed);
    };
    return (
        <GridToolbarContainer sx={{ ...sx, display: 'flex', alignItems: 'center', gap: '12px' }} {...muiProps}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <CustomTooltip
                    title={tooltipMessage || ''}
                    placement="top"
                    open={tooltipOpen}
                    disableHoverListener
                    disableFocusListener
                    disableTouchListener
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {showquickfilter == 1 && (areFiltersAppliedOnSearch ?
                            (
                                <GridToolbarQuickFilter
                                    // value={searchValue}
                                    sx={{
                                        backgroundColor: (
                                            typeof isWeeksToFilterSearchActive !== 'undefined'
                                                ? (isWeeksToFilterSearchActive ? 'rgba(0, 140, 205, 0.12)' : 'transparent')
                                                : (
                                                    (highlightSearchTextOnMainScreenGrid && apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ').trim()?.length > 0)
                                                        ? 'rgba(0, 140, 205, 0.12)'
                                                        : 'transparent'
                                                )
                                        ),
                                        "& input": {
                                            backgroundColor: 'transparent',
                                            height: '32px'
                                        }
                                    }}
                                    onFocus={toolbarmethods?.onSearchFocus ? () => toolbarmethods.onSearchFocus() : undefined}
                                    value={useDebounce
                                        ? inputValue
                                        : (apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '')}
                                    onChange={useDebounce ? handleChangeDebounced : handleChange}
                                    onKeyDown={useDebounce ? handleSubmitDebounced : handleSubmit}
                                />
                            ) : (
                                <GridToolbarQuickFilter quickFilterParser={(searchInput) => {
                                    filterref?.getfiltertext(searchInput);
                                    return searchInput
                                        .split(',')
                                        .map((value) => value.trim())
                                        .filter((value) => value !== '')

                                }
                                }
                                    sx={{
                                        backgroundColor:
                                            (typeof isWeeksToFilterSearchActive !== 'undefined'
                                                ? (isWeeksToFilterSearchActive ? 'rgba(0, 140, 205, 0.12)' : 'transparent')
                                                :
                                                (typeof filterText !== 'undefined' && filterText.trim() !== ""
                                                ? "rgba(0, 140, 205, 0.12)"
                                                : "transparent")
                                            ),
                                        "& input": {
                                            backgroundColor: 'transparent',
                                            height: '32px',
                                        }
                                    }}
                                ></GridToolbarQuickFilter>))}
                     
                        {showSearchButtonInToolbar && searchButton && (
                            <div onClick={useDebounce ? handleSearchClickDebounced : handleSearchClick}>{searchButton}</div>
                        )}
                    </div>
                </CustomTooltip>
            </div>

            {/* Standard Toolbar Buttons */}
            {serverexport =='1' ? (
                <ServerExport toolbarmethods={toolbarmethods} csvbutton={csvbutton} />
            ) : (
                <GridCustomToolBarExport
                    csvoptions={csvoptions}
                    printoptions={printoptions}
                    isallcolumnvisible={isallcolumnvisible}
                />
            )}

            <GridToolbarColumnsButton />
            <GridCustomToolBarFilterButton isallcolumnvisible={isallcolumnvisible} />
        </GridToolbarContainer>
    );
}

function GridCustomToolBarExport(props) {
    return (
        !props.isallcolumnvisible ?
            <div onClick={(event) => { toast.error('At least 1 column should be visbile to export'); }}>
                <GridToolbarExport disabled={true}></GridToolbarExport>
            </div> :
            <GridToolbarExport csvOptions={props.csvoptions} printOptions={props.printoptions}></GridToolbarExport>);
}
function GridCustomToolBarFilterButton(props) {
    return (
        !props.isallcolumnvisible ?
            <div onClick={(event) => { toast.error('At least 1 column should be visbile to apply filter'); }}>
                <GridToolbarFilterButton disabled={true} {...props}></GridToolbarFilterButton>
            </div> :
            <GridToolbarFilterButton {...props} onClick={props.onClick}></GridToolbarFilterButton>
    )
}


function ServerExport(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    // Open the menu on left-click
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuClick = (type) => {
        handleClose();
        props?.toolbarmethods?.downloadcsv(type);
    };

    return (
        (props.csvbutton === 'true') ? (
            <>
                <Button
                    variant="text"
                    size="small"
                    startIcon={<FileDownloadOutlinedIcon />}
                    onClick={handleClick}  // Open menu instead of direct download
                >
                    {"Export"}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => handleMenuClick('csv')}>Export as CSV</MenuItem>
                </Menu>
            </>
        ) : <></>
    );
}

function DefaultFilterPanel(props) {
    const apiRef = useGridApiContext();

    const handleSearchClick = () => {
        const model = apiRef.current.state.filter.filterModel;
        const quickText = (model.quickFilterValues || [''])[0] || '';

        if (props?.onSearchClick) {
            props.onSearchClick(model, quickText);
        }
        apiRef.current.hideFilterPanel();
    };

    return (
        <div>
            <StyledGridFilterPanel {...props} />

            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '8px 16px 12px calc(100% - 254.6px)',
                marginTop: '-47px'
            }}>


                <Button
                    variant="contained"
                    size="small"
                    startIcon={<SearchIcon/> }
                    style={{
                        backgroundColor: '#008ecd',
                        textTransform: 'none',
                        fontSize: '12px',
                        padding: '3px 10px',
                        minHeight: '28px',
                    }}
                    onClick={handleSearchClick}
                >
                    Search
                </Button>
            </div>
        </div>
    );
}

const MemoizedFilterPanel = React.memo(DefaultFilterPanel);


export default withStyles(Styles)(EnhancedDataGrid);